import { ApiIQuestion } from "../../domain/election";
import { PreferenceVote } from "../preference/preference-typedef";
import { VoteFieldValidation, QuestionValidationResult } from "../types";

export const firstPastValidate = (ballot: ApiIQuestion, vote: PreferenceVote): QuestionValidationResult => {
    const { required, voting_config } = ballot;
    if (required) {
        const selected = Object.values(vote).filter(c => c.index !== null)
        if (selected.length === 0) {
            return { valid: false, empty: true }
        }
    }
    if (!voting_config) {
        return { valid: true, empty: false }
    }
    const min_select = voting_config.min_select ? Number(voting_config.min_select) : null;
    const max_select = voting_config.max_select ? Number(voting_config.max_select) : null;

    const reasons: Array<VoteFieldValidation> = [];
    const totalVotes = Object.values(vote).length;
    const candidates = totalVotes + 1;
    const count = Object.values(vote).filter(v => v.index !== null).length
    if (max_select && count > max_select) {
        reasons.push({
            reason: "too_many_candidates",
            meta: { expected: max_select, found: candidates },
        });
    }
    if (min_select && (count === null || count < min_select)) {
        reasons.push({ reason: "not_enough_candidates", meta: { expected: min_select, found: candidates } });
    }
    return {
        valid: reasons.length === 0,
        empty: false,
        reasons,
    };
};
